<template>
    <div class="col-12">
        <div class="search-padd">
            <div class="col-xs-12 override-padding">
                <div class="crm_admin_heading account_history text-left"></div>
            </div>
            <div style="clear: both;"></div>
            <div v-show="loading" class="loading_show"><div class="spinner-border text-danger"></div></div>
            <div style="clear: both;" class="margin-bottom-10"></div>
            <div v-if="!isEmptyHistory">
                <div class="history_tab" v-for="(history, hindex) in historylists" :key="hindex">
                    <div class="account_history updated_title">
                        Updated on: {{ history.updated_on | formatUpdatedDate }} By: {{ history.updated_by }}
                    </div>
                    <div style="clear: both;"></div>
                    <div class="col-12 override-padding mt-2">
                        <div class="crm_admin_history history_heading_1 text-left">Field</div>
                        <div class="crm_admin_history history_heading_2 text-left">From: </div>
                        <div class="crm_admin_history history_heading_3 text-left">To:</div>
                        <div class="crm_admin_history history_heading_4 text-left">Time:</div>
                    </div>
                    <div style="clear: both;"></div>
                    <div v-for="(audit, findex) in history.field_updates" :key="findex" class="">
                        <div class="crm_admin_field_lists history_heading_1 text-left">
                            {{ audit.field_name + " : " }}
                        </div>
                        <div class="crm_admin_field_lists history_heading_2 text-left">
                            {{ audit.old_value }}
                        </div>
                        <div class="crm_admin_field_lists history_heading_3 text-left">
                            {{ audit.new_value }}
                        </div>
                        <div class="crm_admin_field_lists history_heading_4 text-left">
                            {{ audit.updated_time }}
                        </div>
                        <div style="clear: both;" :class="getEntryLine(audit.is_same_time)"></div>
                    </div>
                </div>
            </div>
            <div v-else>
                <div class="history_tab">No History Found</div>
            </div>
            <div style="clear: both;"></div>
        </div>
    </div>
</template>
<script>
import Vue from 'vue/dist/vue.esm';
import axios from 'axios';
import moment from 'moment';

Vue.filter('formatUpdatedDate', function(value) {
  if (value) {
    return moment(String(value)).format('MMM.DD, YYYY')
  }
});

export default {
    props: ['accountId'],
    data() {
        return {
            loading: false,
            historylists: [],
            isEmptyHistory: 0,
        }
    },
    methods: {
        loadAccountAuditTrailAction() {
            this.loading = true;
            axios("/enterprise_lookup_audit_trail", {
                method: 'GET',
                params: {
                    account_id: this.accountId,
                }
            })
            .then(response => {
              this.loading = false;
              this.historylists = response.data;
              if (Array.isArray(this.historylists) && !this.historylists.length) {
                  this.isEmptyHistory = 1;
              }
            })
            .catch(error => {

            });
        },
        getEntryLine(is_same_time) {
            var className = '';
            if (is_same_time == 1) {
                className = 'entry_line';
            }
            return className;
        }
    },
    created() {
        this.loading = false;
        this.loadAccountAuditTrailAction();
    }
}
</script>
<style scoped>
.account_history { width: 100%; }
.updated_title { text-align: left; font-weight: 900; margin: 0 2px; }
.history_tab {
    background-color: #dcdcdc !important;
    color: #000;
    padding: 10px;
    margin: 10px 0;
    width: 100%;
    display: inline-block;
    position: relative;
}
.history_tab:after {
  position: absolute;
  content: '';
  border-bottom: 1px dotted #c1bfbf;
  width: 100%;
  transform: translateX(-50%);
  bottom: -15px;
  left: 50%;
  margin-bottom: 5px;
}
.crm_admin_history {
    border-top: 0 none;
    float: left;
    line-height: 1.42857;
    padding: 8px 3px;
    vertical-align: bottom;
    font-weight: 900;
}
.history_heading_1 { width: 15%; }
.history_heading_2 { width: 35%; }
.history_heading_3 { width: 35%; }
.history_heading_4 { width: 15%; }
.entry_line { border-bottom: 1px dotted #000; }
</style>


// WEBPACK FOOTER //
// src/components/admin/account_lookup_history_tab.vue